import React, { Context } from 'react';
import { AppContext, AppContextInterface } from '../app-context-provider';
import LabelIcon from './file-icon';
import { ReactComponent as ArrowDown } from '../assets/images/Arrow-Down.svg';
import { FileItem } from '../components/component-switcher';
import SolidIconDownloadLink from './solid-icon-download-link';
import Img from './Img';

export interface LabelComponentProps {
  item: FileItem;
}

export interface LabelComponentState {}

class LabelComponent extends React.Component<
  LabelComponentProps,
  LabelComponentState
> {
  static contextType: Context<AppContextInterface | null> = AppContext;
  static context: AppContextInterface;
  state: LabelComponentState = {};

  constructor(props: LabelComponentProps) {
    super(props);
    this.downloadLabel = this.downloadLabel.bind(this);
  }

  public downloadLabel(event: React.MouseEvent<HTMLElement>): void {
    console.log(event);
  }

  public showPreviews() {
    return this.props.item.previewImages?.map((image) => (
      <Img
        key={image.key}
        src={image.previewImageUrl}
        alt={`${this.props.item.title} - ${this.props.item.description}`}
      />
    ));
  }

  render() {
    let downloadButtonText = (
      <span className='download-text'>
        Download &nbsp;
        <span className='bold-text'>{this.props.item.fileExtension}</span>
      </span>
    );
    let downloadButtonIcon = <ArrowDown />;
    let fileName = this.props.item.title + this.props.item.fileExtension;

    return (
      <div className='label-component'>
        <div className='item-image-container'>
          {this.props.item.fileUrl !== undefined &&
          this.props.item.fileUrl !== '' ? (
            <Img
              src={this.props.item.fileUrl}
              alt={`${this.props.item.title} - ${this.props.item.description}`}
            />
          ) : (
            this.showPreviews()
          )}
        </div>

        <h4>{this.props.item.title}</h4>
        <span
          dangerouslySetInnerHTML={{ __html: this.props.item.description }}
          className='item-image-text'
        />

        <div className='item-downloads-container'>
          <SolidIconDownloadLink
            fileName={fileName}
            target='_black'
            link={this.props.item.filePath}
            download={true}
            iconStyle={{ fill: 'white', stroke: 'white' }}
            hoverText=''
            fontSize='10px'
            buttonText={downloadButtonText}
            icon={downloadButtonIcon}
            className='download-button'
          />
          <LabelIcon name={this.props.item.fileExtension} />
        </div>
      </div>
    );
  }
}

export default LabelComponent;
